import React from 'react'
import FavoritesLayout from 'presentation/doctor/layouts/Favorites'

export const DoctorFavorites = () => {
  return <FavoritesLayout />
}
